export default __webpack_public_path__ + "static/media/logo.cad1b274.png";